import { createContext, useContext } from 'react';

const EventsIndexContext = createContext({
  selectedEvent: null,
  setSelectedEvent: null, // (id) => {}
  isMapDisplayed: false,
  onEventCardClick: null, // (event) => {},
  eventBeingDeleted: null,
  hiddenUsersIds: null,
  setHiddenUsersIds: null,
  refreshMapMarkersRef: null,
  subscribeToEventDeletedHandlers: null,
  unsubscribeFromEventDeletedHandlers: null,
});

export const EventsIndexContextProvider = ({ children, ...value }) => (
  <EventsIndexContext.Provider value={value}>
    {children}
  </EventsIndexContext.Provider>
);

export const useEventsIndexContext = () => useContext(EventsIndexContext);

export const withEventsIndexContext = (Component) => (props) => {
  const contextValue = useEventsIndexContext();

  return <Component {...contextValue} {...props} />;
};

export default EventsIndexContext;
